module.exports = __webpack_public_path__ + "img/njm_g1-3.prt.7f829761.jpg";